import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';

import {
	PublicClientApplication,
	EventType,
	EventMessage,
	AuthenticationResult,
	InteractionType,
} from '@azure/msal-browser';
import { loginRequest, msalConfig } from './authConfig';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import store from './store/store';
import './index.scss';
import { FormikRefsProvider } from './contexts/CustomFormikContext';
import { getToken, injectStore, isTokenExpired } from './services/api/axios';

export const msalInstance = new PublicClientApplication(msalConfig);
//get initialize msalInstance
msalInstance.initialize().then(async () => {
	const activeAccount = msalInstance.getActiveAccount();
	if (!activeAccount) {
		// Account selection
		const accounts = msalInstance.getAllAccounts();
		if (accounts?.length > 0) {
			msalInstance.setActiveAccount(accounts[0]);
		}
	}
	//set the account
	msalInstance.addEventCallback((event: EventMessage) => {
		if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
			const authenticationResult = event.payload as AuthenticationResult;
			const account = authenticationResult.account;
			msalInstance.setActiveAccount(account);
		}
	});

	injectStore(store);

	//enable account storage event
	msalInstance.enableAccountStorageEvents();
	ReactDOM.createRoot(document.getElementById('root')!).render(
		<React.StrictMode>
			<MsalProvider instance={msalInstance}>
				<MsalAuthenticationTemplate
					interactionType={InteractionType.Redirect}
					authenticationRequest={loginRequest}
				>
					<Provider store={store}>
						<FormikRefsProvider>
							<App />
						</FormikRefsProvider>
					</Provider>
				</MsalAuthenticationTemplate>
			</MsalProvider>
		</React.StrictMode>,
	);
});
